// extracted by mini-css-extract-plugin
export default {"button":"style_button__L2k1Q"};